import React from 'react';
import Viewer from '../../Viewer';
import { extConfigFullscreen } from '../../../Editor/presets/Gallection/config';
import type { ExternalReactRenderers } from '../../../Editor/types';
import cn from 'classnames';
import { Measureable } from '../../types';

import s from './Gallection.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const GallectionViewer = React.forwardRef<HTMLDivElement, Props>(
  (
    { contentJson, className, externalRenderers, cookieType, defaultSize },
    ref
  ) => {
    return (
      <Viewer
        presetId="gallection"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfigFullscreen}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
GallectionViewer.displayName = 'GallectionViewer';

export default GallectionViewer;
